<template src="../template/web_videoView.html"></template>

<script>
export default {
  name: 'liveVideoStream'
}
</script>

<style scoped>

</style>
